import styled from "styled-components";

export const FileButton = styled.button`
  background: white;
  border: 1px solid #104467;
  border-radius: 3px;
  cursor: pointer;
  padding: 10px;
  margin: 3px;
  color: #104467;
  width: 100%;
  height: 50px;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
`;

export const FileItem = styled.div`
  width: 100%;
  border: 1px solid #104467;
  border-radius: 5px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;

  &:hover {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.05);
  }
`;
